// A draft pick in a few words, for a row with no room for its full name
// (PLAN-2026-10-27-the-next-season §2.6): "2027 1st (GG)", the seat it
// belongs to by its team's abbreviation. Sleeper's rows read the same way.

import type { DraftPickRef } from '@fsp/domain';

/** 1st, 2nd, 3rd, 4th … 11th, 12th, 13th, 21st. */
function ordinal(n: number): string {
  const teen = n % 100 >= 11 && n % 100 <= 13;
  const suffix = teen ? 'th' : (['th', 'st', 'nd', 'rd'][n % 10] ?? 'th');
  return `${String(n)}${suffix}`;
}

export function pickShort(pick: DraftPickRef): string {
  return `${String(pick.season)} ${ordinal(pick.round)} (${pick.team.abbreviation})`;
}
